import { render, staticRenderFns } from "./xjcqdform.vue?vue&type=template&id=28f1ac1c&scoped=true&"
import script from "./xjcqdform.vue?vue&type=script&lang=js&"
export * from "./xjcqdform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f1ac1c",
  null
  
)

export default component.exports